import { useEffect } from "react";
import { startSardine } from "services/sardine";

export const SardineProvider = ({ children }) => {
  useEffect(() => {
    startSardine();
  }, []);

  return <>{children}</>;
};
